
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M89.6 0H38.4C17.2 0 0 17.2 0 38.4v51.2C0 110.8 17.2 128 38.4 128h51.2c21.2 0 38.4-17.2 38.4-38.4V38.4C128 17.2 110.8 0 89.6 0zm-47 8.8h42.7v28.1c-3.6 2.2-7.4 5-11 8.9V19.6H53.6v26.2c-3.2-3.5-7-6.4-11-8.9V8.8zm6.3 91v19.1h-5v-9.6s.6-4.7-4.5-4.7H13.9v-4.5h28.9c1.3 0 1.3-1.9 0-1.9H13.9v-4.4h30.6c5 0 4.4 2.2 4.4 6zm7-12.7v31.8h-5V96.6s.6-4.7-4.5-4.7H13.9v-4.5h36c1.2 0 1.2-1.9 0-1.9h-36V81h37.6c5 .1 4.4 2.2 4.4 6.1zm7.1 31.8h-5V83.8s.6-4.7-4.5-4.7H13.9v-4.4H57c1.2 0 1.2-1.9 0-1.9H13.9v-4.4h44c3.1.6 5 3.7 5 6.9v43.6zm51-20.6H85c-1.3 0-1.3 1.9 0 1.9h29v4.5H88.5c-5.2 0-4.5 4.7-4.5 4.7v9.6h-5V99.8c0-3.9-.6-6 4.4-6H114v4.5zm0-12.7H78c-1.2 0-1.2 1.9 0 1.9h36V92H81.5c-5.2 0-4.5 4.7-4.5 4.7V119h-5V87.1c0-3.9-.6-6 4.4-6H114v4.5zm0-12.8H70.9c-1.2 0-1.2 1.9 0 1.9H114v4.4H74.5c-5.1 0-4.5 4.7-4.5 4.7v35.1h-5V75.3c0-3.3 1.9-6.3 5-6.9h44v4.4zm0-6.4h-11.4V43.5c-4.9.6-14.6 5.8-19.6 11.8h16.7v11.2H13.9v-22h11.2v10.8h19.7C38.5 48 25.1 41.7 13.9 42.1V22.5h27.2v11.2H32c16.3 5.5 28 19.2 31.9 32.6 4.9-15.3 16.9-27.4 32-32.6h-9.2V22.5h15.9v-3.2H114v47.1z"}}),_c('path',{attrs:{"d":"M63.8 66.4h.2c0-.1 0-.1-.1-.2 0 .1 0 .2-.1.2z"}})])
          )
        }
      }
    